export default [
  { value: false, key: "status.active" },
  { value: true, key: "status.inactive" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/enums/memberCoverageStatuses.js